import React, { useState } from 'react';
import { BasePage, ReleaseToggle } from '@sm/webassets';

import CovidEndpage from '../CovidEndpage';
import EmbeddedNonBrandedHeader from '~app/components/EmbeddedNonBrandedHeader';
import Embedded from '../Embedded';
import NonBranded from '../NonBranded';
import PollingEndpage from '../PollingEndpage';
import RebrandEpForm from '../RebrandEpForm';
import RebrandEpFormIntl from '../RebrandEpFormIntl';
import RebrandExistingUser from '../RebrandExistingUser';
import Research from '../Research';
import StandardEndpage from '../StandardEndpage';

function EndpageTemplates(): React.ReactElement {
  const [templateSelected, setTemplateSelected] = useState(false);

  return (
    <>
      <ReleaseToggle toggleId="Polling">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <PollingEndpage
                defaultEndpage={<StandardEndpage pageName="PollingUSMap" utSource="survey-thanks" />}
                pollingExperiment=""
                pollingTreatment=""
              />
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="CorporateSignatureResearchEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <StandardEndpage pageName="CorporateSignatureResearchEndpage" utSource="survey-thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="CxEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="GiancarloEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <StandardEndpage pageName="GiancarloEndpage" utSource="survey-thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="MrxEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <StandardEndpage pageName="MrxEndpage" utSource="survey-thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RacialJusticeEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <StandardEndpage pageName="RacialJusticeEndpage" utSource="survey-thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>

      <ReleaseToggle toggleId="EmbeddedNonBranded">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <EmbeddedNonBrandedHeader message="Hello World" icon="thanks" />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="EmbeddedBranded">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <Embedded />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="NonBranded">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <NonBranded />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="Research">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return <Research />;
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="CovidEndpage">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <CovidEndpage />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandEpFormIntl">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandEpFormIntl />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandExistingUser">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandExistingUser />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>
      <ReleaseToggle toggleId="RebrandEpForm">
        {(showToggle: boolean) => {
          if (showToggle) {
            setTemplateSelected(true);
            return (
              <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
                <RebrandEpForm />
              </BasePage>
            );
          }
          return <> </>;
        }}
      </ReleaseToggle>

      {!templateSelected && (
        <BasePage includeHeader={false} includeFooter pageId="Survey Thanks" legacyWeb="anonweb">
          <RebrandEpForm />
        </BasePage>
      )}
    </>
  );
}

export default EndpageTemplates;
